import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import { MaskedLines, Reveal } from "@/components/motion";
import { usePageMeta } from "@/hooks/usePageMeta";

const PaymentCancel = () => {
  usePageMeta("Payment Cancelled | Heartland Physics", "Your payment was cancelled — no charge was made.");
  return (
    <section data-testid="payment-cancel-page" className="border-b border-border bg-blueprint-grid pt-16">
      <div className="mx-auto max-w-3xl px-5 py-20 md:px-8 md:py-28">
        <Reveal y={12}>
          <p className="eyebrow">Payment</p>
        </Reveal>
        <h1 className="mt-6 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl">
          <MaskedLines delay={0.1} lines={["No charge made."]} />
        </h1>
        <Reveal delay={0.3}>
          <div className="mt-10 border border-border bg-white p-7" data-testid="payment-cancel-card">
            <div className="flex items-center gap-3">
              <XCircle size={22} className="text-ink/40" />
              <p className="font-heading text-base font-bold tracking-tight text-ink">Checkout was cancelled.</p>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-ink/70">
              Nothing was charged. Whenever you're ready, the intake form and secure checkout will be right where you left them.
            </p>
            <Link
              to="/request"
              data-testid="payment-cancel-back"
              className="group mt-6 inline-flex items-center gap-2 text-sm font-semibold text-blueprint transition-colors hover:text-ink"
            >
              <ArrowLeft size={15} className="transition-transform duration-200 group-hover:-translate-x-1" />
              Back to the request page
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default PaymentCancel;
